var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizMito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 95,
    viewBox: "0 0 111 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FAC600",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.364
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.261 90.494c-14.503 0-26.303-11.93-26.303-26.592V37.309H63.26c14.503 0 26.303 11.93 26.303 26.593s-11.8 26.592-26.303 26.592zM36.958 5v32.309H5z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#2BC5CD",
    fillRule: "nonzero",
    d: "M90.873 52.717c2.447 0 4.431 2.003 4.431 4.474 0 .93-.28 1.793-.761 2.508l.005-.055c0 .055-.01.109-.029.16l-3.408 9.257a4.646 4.646 0 0 1-4.36 3.042H76.384a4.646 4.646 0 0 1-4.32-2.935l-2.652-6.69-2.423 6.583a4.646 4.646 0 0 1-4.36 3.042H52.26a4.646 4.646 0 0 1-4.32-2.935l-2.974-7.504h-25.6c-2.447 0-4.43-2.002-4.43-4.473 0-2.47 1.983-4.474 4.43-4.474h71.506z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A64",
    d: "M103.723 37.4a.64.64 0 0 0-.634-.588.64.64 0 0 0-.634.589c-.32 3.56-3.146 6.391-6.683 6.677a.642.642 0 0 0-.591.64v.156c0 .337.258.613.59.64 3.538.286 6.364 3.117 6.684 6.678a.64.64 0 0 0 .634.59.64.64 0 0 0 .634-.59c.32-3.561 3.146-6.392 6.684-6.678a.642.642 0 0 0 .59-.64v-.155a.642.642 0 0 0-.59-.641c-3.538-.286-6.364-3.116-6.684-6.677",
    style: {
      mixBlendMode: "multiply"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizMito);
export default __webpack_public_path__ + "static/media/biz-mito.247d56a8ef96218bee3921d3ae279728.svg";
export { ForwardRef as ReactComponent };